<div
    class="u-mdBottomMargin agpr-keywordsInput"
    [ngClass]="styleClass"
>
    <label>
        <span class="u-fontSize3 u-block u-xsBottomMargin">
            <span *ngIf="labelType === inputTypesEnum.html" [innerHTML]="label"></span>
            <ng-container *ngIf="labelType === inputTypesEnum.template">
                <ng-container *ngTemplateOutlet="label"></ng-container>
            </ng-container>
            <ng-container *ngIf="labelType === inputTypesEnum.text">
                {{ label }}
            </ng-container>
        </span>
        <agpr-text-input-chips
            [id]="id"
            [disabled]="disabled"
            [placeholder]="placeholder | localize"
            [splitOnPattern]="splitOnPattern"
            [trimQuotes]="true"
            [chipValidations]="keywordValidations"
            [(ngModel)]="value"
            (ngModelChange)="handleChanges()"
        ></agpr-text-input-chips>
    </label>
</div>
